import React from 'react';

import { Typography } from '@occc/ui-design-system';
import { FormInput } from '@occc-app/Offer/components/FormInput';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { actions, State } from '../redux';
import { FormCheckbox } from '../../FormCheckbox';

const MustFulfillWithinDaysFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type Actions = typeof actions;
type ComponentState = State['requiresActivation'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  constraintConfigurationUpdate: Actions['constraintConfigurationUpdate'];
  fieldDisabled: (field: Fields) => boolean;
  readOnly?: boolean;
};
const RequiresActivationConfiguration: React.FC<Props> = (props) => {
  const {
    constraintConfigurationUpdate,
    fieldDisabled,
    mustFulfillWithinDays,
    mustFulfillWithinDaysActive,
    readOnly,
  } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value: boolean | number | string = event.currentTarget.value;
    value =
      event.currentTarget.type.toLowerCase() === 'checkbox'
        ? event.currentTarget.checked
        : parseInt(value, 10);

    constraintConfigurationUpdate('requiresActivation', event.currentTarget.id, value);
  };

  const formLabelCopy = !readOnly
    ? 'Further activation configuration options:'
    : 'Activation Required';
  const formLabelComponent = <Typography paragraph>{formLabelCopy}</Typography>;

  const renderMustFulfillWithinDaysComponent = () => {
    if (readOnly && !(readOnly && mustFulfillWithinDaysActive)) {
      return;
    }

    const mustFulfillWithinDaysCheckbox = !readOnly && (
      <FormCheckbox
        id='mustFulfillWithinDaysActive'
        label='Must Fulfill Within'
        onChange={handleChange}
        disabled={fieldDisabled('mustFulfillWithinDaysActive')}
        checked={mustFulfillWithinDaysActive}
      />
    );

    const mustFulfillWithinDaysInput = mustFulfillWithinDaysActive && (
      <MustFulfillWithinDaysFormInput
        id='mustFulfillWithinDays'
        type='text'
        label={readOnly ? 'Must Fulfill Within (Days)' : 'Days'}
        onChange={handleChange}
        readonly={fieldDisabled('mustFulfillWithinDays')}
        value={mustFulfillWithinDays}
        required={true}
      />
    );

    return (
      <>
        {mustFulfillWithinDaysCheckbox}
        {mustFulfillWithinDaysInput}
      </>
    );
  };

  return (
    <>
      {formLabelComponent}
      {renderMustFulfillWithinDaysComponent()}
    </>
  );
};

export { RequiresActivationConfiguration };
